import { render, staticRenderFns } from "./fall.vue?vue&type=template&id=315183a6&scoped=true&"
import script from "./fall.vue?vue&type=script&lang=js&"
export * from "./fall.vue?vue&type=script&lang=js&"
import style0 from "./fall.vue?vue&type=style&index=0&id=315183a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315183a6",
  null
  
)

export default component.exports